export enum UserRoleEnum {
  ANALYST = 'analista_liquidaciones'
}
